import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../utils/cn';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-cream-300 last:border-0" data-id="element-66">
      <button onClick={onClick} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-67">
        <span className="text-xl font-bold font-heading text-warmBrown-900 pr-8" data-id="element-68">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="shrink-0 text-terracotta" data-id="element-69">
          <ChevronDown className="w-6 h-6" data-id="element-70" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-71">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-72">
            <p className="pb-6 text-lg text-warmBrown-700 leading-relaxed" data-id="element-73">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Realmente funciona con niños fuertes de carácter?',
    a: 'Sí, los niños de carácter fuerte son los que más necesitan seguridad y límites claros, no gritos.'
  }, {
    q: '¿Es necesario que mi esposo también lo lea?',
    a: 'Sería ideal, pero si solo tú cambias tu forma de responder, la dinámica de toda la casa empezará a sanar.'
  }, {
    q: '¿Cuánto tiempo me tomará ver resultados?',
    a: 'El alivio de saber qué hacer es inmediato. Los cambios de conducta suelen verse entre el día 3 y el día 7.'
  }];
  return <section className="py-20 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <FadeIn data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-77">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-78">
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-cream-200" data-id="element-79">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-80" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}